(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalPagination', [RfGlobalPaginationDirectiveFn]);

    /* directive for the agenda pagination */
    function RfGlobalPaginationDirectiveFn() {

        var directive = {
            restrict: 'E',
            templateUrl: '/app/global/templates/rf-global-pagination.template.html',
            scope: {
                overview: '='
            },
            link: link
        };
        return directive;
        function link(scope, element) {
            
        }
    }

})();